import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://quickbookapi.nebulastudios.in/admin';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('qb_admin_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
            localStorage.removeItem('qb_admin_token');
            window.location.href = '/login';
        }
        return Promise.reject(err);
    }
);

export const authAPI = {
    login: (data) => api.post('/auth/login', data),
    verify: () => api.get('/auth/verify'),
};

export const dashboardAPI = {
    getStats: () => api.get('/dashboard/stats'),
};

export const doctorsAPI = {
    getAll: (params) => api.get('/doctors', { params }),
    getById: (id) => api.get(`/doctors/${id}`),
    updateStatus: (id, status) =>
        api.patch(`/doctors/${id}/status`, { status }),
    delete: (id) => api.delete(`/doctors/${id}`),
    getAppointments: (id) => api.get(`/doctors/${id}/appointments`),
    approve: (id) => api.put(`/doctors/${id}/approve`),
    reject: (id) => api.put(`/doctors/${id}/reject`)
};

export const patientsAPI = {
    getAll: (params) => api.get('/patients', { params }),
    getById: (id) => api.get(`/patients/${id}`),
    updateStatus: (id, status) =>
        api.patch(`/patients/${id}/status`, { status }),
    delete: (id) => api.delete(`/patients/${id}`),
};

export const appointmentsAPI = {
    getAll: (params) => api.get('/appointments', { params }),
    getById: (id) => api.get(`/appointments/${id}`),
    updateStatus: (id, status) =>
        api.patch(`/appointments/${id}/status`, { status }),
};

export const countriesAPI = {
    getAll: (params) => api.get('/countries', { params }),
    create: (data) => api.post('/countries', data),
    update: (id, data) => api.put(`/countries/${id}`, data),
    delete: (id) => api.delete(`/countries/${id}`),
};

export const checkupsAPI = {
    getAll: (params) => api.get('/checkups', { params }),
    getById: (id) => api.get(`/checkups/${id}`),
    getByAppointmentId: (appointmentId) =>
        api.get(`/appointments/${appointmentId}/checkup`),
    create: (data) => api.post('/checkups', data),
    update: (id, data) => api.patch(`/checkups/${id}`, data),
};

export const ratingsAPI = {
    getAll: (params) => api.get('/ratings', { params }),
    getById: (id) => api.get(`/ratings/${id}`),
    getByDoctorId: (doctorId, params) =>
        api.get(`/doctors/${doctorId}/ratings`, { params }),
    getDoctorStats: (doctorId) => api.get(`/doctors/${doctorId}/ratings/stats`),
    create: (data) => api.post('/ratings', data),
    update: (id, data) => api.patch(`/ratings/${id}`, data),
    delete: (id) => api.delete(`/ratings/${id}`),
};

export default api;
